import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import { FilterEnum } from 'src/app/core/api/models';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { SelectSearchModule } from 'src/app/shared/components/select-search/select.search.module';
import { SpecialLoadingModule } from 'src/app/shared/components/special-loading/special-loading.module';
import { ListGroupItemModule } from 'src/app/shared/global/list-group-item/list-group-item.module';



@Component({
    selector: 'app-view-filters',
    templateUrl: './view-filters.component.html',
    styleUrls: ['./view-filters.component.scss'],
    imports: [
        BaseFormModule,
        SpecialLoadingModule,
        SelectSearchModule,
        ListGroupItemModule,
    ]
})
export class ViewFiltersComponent implements OnInit, OnChanges {
  @Input() filters: FilterEnum[] | null;
  @Input() filterToDisplay: any;

  _displayText = '';

  @Output() DisplayText: EventEmitter<string> = new EventEmitter<string>();

  constructor(private cd: ChangeDetectorRef) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (this.filters != null) {
      this.createDisplayText();
    }
  }

  isInDisplayFilter(filter: FilterEnum) {
    return this.filterToDisplay[filter.enumName] != null;
  }

  getFilterText(filter: FilterEnum) {
    if (this.filterToDisplay[filter.enumName] != null) {
      var resultText = '';
      var isFirst = true;
      this.filterToDisplay[filter.enumName].forEach((element) => {
        if (isFirst) {
          resultText += element;
          isFirst = false;
        } else {
          if (filter.enumName == 'age') resultText += ' - ' + element;
          // else {
          //   return element;
          // }
        }
      });
      return resultText;
    } else {
      return filter.enumTitle;
    }
  }

  createDisplayText() {
    this.cd.detectChanges();
  }

  ngOnInit(): void {}
}
